export default __webpack_public_path__ + "static/media/PERSO_3.14475a60.gif";